var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.72 9.26 3.772-3.77.953.953-4.724 4.724-4.61-4.61.954-.953L8.72 9.26Z",
    fill: "#555249"
  })));
};

export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzIwOTEgOS4yNjA0MkwxMi40OTE2IDUuNDg5NzVMMTMuNDQ0OSA2LjQ0MzA1TDguNzIxMjkgMTEuMTY2Nkw0LjExMTMzIDYuNTU3MjJMNS4wNjQ1MiA1LjYwNDAzTDguNzIwOTEgOS4yNjA0MloiIGZpbGw9IiM1NTUyNDkiLz4KPC9zdmc+Cg==";